import { gql } from '@apollo/client';

export const QUERY_BOOKING_DETAILS = gql`
  query FetchBookingDetails($bookingId: String, $profileType: String) {
    fetchBookingDetails(bookingId: $bookingId, profileType: $profileType) {
      success
      frontProgress {
        status
        title
        date
        description
      }
      Progress {
        status
        title
        date
        description
      }
      data {
        bookingOwner
        cargoLoad
        numberOfTrucks
        linerQuotations
        referenceId
        quotationExpiryDate
        _id
        packages
        bookingAction
        incoTerm
        poNumber
        bookingNo
        currentStatus
        buyerId
        supplierId
        forwarderId
        buyerUserId
        supplierUserId
        forwarderUserId
        statusHistory {
          statusName
          statusDate
          createdBy
          subdata
          _id
        }
        costDetails {
          docName
          invoiceNumber
          invoiceName
          amount
          currency
          uploadedAt
          uploadedBy
        }
        eventAction {
          _id
          type
          currentStatus
          profileType
          Accept
          Reject
          ProposeChange
          AddBooking
          ManualUpdate
          CreateShipment
        }
        buyerCollaborators {
          userId
          invitedBy
          invitedOn
          status
          _id
        }
        supplierCollaborators {
          userId
          invitedBy
          invitedOn
          status
          _id
        }
        forwarderCollaborators {
          userId
          invitedBy
          invitedOn
          status
          _id
        }
        shipmentList {
          _id
          shipmentNo
          BLno
          currentStatus
          mode
          bookingType
          currentCustomStatus
          CustomCount
        }
        createdBy
        bookingDate
        orderID
        mode
        translatedMode
        translatedBookingType
        shipmentType
        containerType
        originFacility
        destinationFacility
        isSpacialEquipment
        typeofMove
        notes
        cargoType
        scheduledPickupDate
        scheduledPickupToDate
        equipmentType
        address {
          type
          portName
          street
          city
          state
          country
          zipcode
          id
        }
        entities {
          type
          name
        }
        lineItems {
          itemName
          itemCode
          description
          price
          quantity
          grossWeight
          weightUnit
          volumeWeight
          dimensions {
            length
            height
            width
            _id
          }
          discountAmt
          discountPer
          total
          dueDate
          notes
          _id
          statusName
          lineItemStatus {
            statusName
            statusDate
            createdBy
            createdDate
            _id
          }
        }
        createdAt
        updatedAt
        attachment {
          _id
          createdAt
          deleted
          docId
          filePath
          originalFileName
          type
          uploadedBy
          url
        }
        kindOfGoods
        customClearance
        hazmat
        hsCode
        unCode
        cargoReadyDate
        isRFQ
        isContracted
        truckType
        contractDetails
        customEntries
        shipperEntityDetails
        consigneeEntityDetails
        consigneeEntityDetailsList
        ShipperDetails {
          orgName
          orgAddress
          orgState
          orgZip
          orgCountry
          orgPhone
          orgEmail
          orgWebsite
          orgLogo
          orgCover
          orgDescription
          defaultCurrency
          orgERPValue
          entityERPValue
          _id
        }
        ConsigneeDetails {
          orgName
          orgAddress
          orgState
          orgZip
          orgCountry
          orgPhone
          orgEmail
          orgWebsite
          orgLogo
          orgCover
          orgDescription
          defaultCurrency
          orgERPValue
          entityERPValue
          _id
        }
        ForwarderDetails {
          orgAddress
          orgCountry
          orgCover
          orgDescription
          orgEmail
          orgLogo
          orgName
          orgPhone
          orgState
          orgZip
        }
        shipmentNo
        shipmentId
        pickupDelivery
        bookHandle
        bookingType
        isPickUpScheduledPopup
        paymentMethod
        serviceLevel
      }
    }
  }
`;

export const GET_ALL_ATTACHMENTS = gql`
  query GetAllAttachments($input: getDocumentsParams) {
    GetAllAttachments(input: $input) {
      success
      data
      totalAttachments
      currentPage
      totalPages
      message
    }
  }
`;

export const FOLDER_FILES = gql`
  query PoGetFiles($input: poGetFilesInput) {
    PoGetFiles(input: $input) {
      success
      data
      showFilter
      totalAttachments
      currentPage
      totalPages
      message
      breadCrumb
      action
    }
  }
`;

export const UPLOAD_DOCUMNET = gql`
  mutation PoUploadDocument($input: uploadDocumentInput) {
    PoUploadDocument(input: $input) {
      success
      message
      data
    }
  }
`;

export const DELETE_DOCUMENT = gql`
  mutation PoDeleteDocument($input: deleteDocumentInput) {
    PoDeleteDocument(input: $input) {
      success
      message
      data
    }
  }
`;

export const RENAME_DOCUMENT = gql`
  mutation PoRenameDocument($input: renameDocumentInput) {
    PoRenameDocument(input: $input) {
      success
      message
      data
    }
  }
`;

export const APPROVE_QUOTATION = gql`
  mutation ApproveQuotation($input: approveQuotationInput) {
    ApproveQuotation(input: $input) {
      success
      data
      message
    }
  }
`;

export const APPROVE_QUOTATION_REQUEST = gql`
  mutation UpdateQuotation($input: updateQuotationInput) {
    UpdateQuotation(input: $input) {
      success
      data
      message
    }
  }
`;

export const SAVE_INVOICE = gql`
  mutation SaveInvoiceDetails($input: saveInvoiceInput) {
    saveInvoiceDetails(input: $input) {
      data
      message
      success
    }
  }
`;
